var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "InfoOutlined"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.33594 4.66634H8.66927V5.99967H7.33594V4.66634ZM7.33594 7.33301H8.66927V11.333H7.33594V7.33301ZM8.0026 1.33301C4.3226 1.33301 1.33594 4.31967 1.33594 7.99967C1.33594 11.6797 4.3226 14.6663 8.0026 14.6663C11.6826 14.6663 14.6693 11.6797 14.6693 7.99967C14.6693 4.31967 11.6826 1.33301 8.0026 1.33301ZM8.0026 13.333C5.0626 13.333 2.66927 10.9397 2.66927 7.99967C2.66927 5.05967 5.0626 2.66634 8.0026 2.66634C10.9426 2.66634 13.3359 5.05967 13.3359 7.99967C13.3359 10.9397 10.9426 13.333 8.0026 13.333Z",
    fill: "black",
    fillOpacity: 0.38
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.f77224efbd0f5a0f42a9fba218111dfa.svg";
export { ForwardRef as ReactComponent };